import { apiClient } from "services/Api";

const DEFAULT_MAX_ATTEMPTS = 60;
const DEFAULT_DELAY_MS = 5000;

export const triggerDownloadFromUrl = async (
  downloadUrl,
  filename = "candidatura.pdf",
) => {
  void filename;
  const newWindow = window.open(downloadUrl, "_blank", "noopener,noreferrer");
  if (newWindow) {
    newWindow.opener = null;
  }
};

export const requestApplicationPdfExport = async ({
  typology,
  applicationId,
}) => {
  const response = await apiClient.get(`/application/${typology}/${applicationId}/`, {
    params: { file: "pdf" },
    responseType: "json",
    validateStatus: () => true,
  });

  if (response.status === 202 && response.data?.task_id) {
    return {
      status: "PENDING",
      taskId: response.data.task_id,
    };
  }

  if (response.status === 200 && response.data?.download_url) {
    return {
      status: "SUCCESS",
      taskId: response.data?.task_id || "",
      filename: response.data?.filename || "",
      downloadUrl: response.data.download_url,
    };
  }

  throw new Error(response.data?.error || "Não foi possível iniciar a exportação");
};

export const waitForApplicationPdfExport = async ({
  typology,
  applicationId,
  taskId,
  maxAttempts = DEFAULT_MAX_ATTEMPTS,
  delayMs = DEFAULT_DELAY_MS,
}) => {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const response = await apiClient.get(
      `/application/${typology}/${applicationId}/export/task/${taskId}/`,
      {
        responseType: "json",
        validateStatus: () => true,
      },
    );

    if (response.status === 202) {
      await new Promise((resolve) => setTimeout(resolve, delayMs));
      continue;
    }

    if (response.status === 200 && response.data?.download_url) {
      return {
        status: "SUCCESS",
        taskId,
        filename: response.data?.filename || "",
        downloadUrl: response.data.download_url,
      };
    }

    throw new Error(response.data?.error || "Exportação falhou");
  }

  throw new Error("Tempo de espera esgotado");
};
